import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
export function PackEliteSection() {
  return <Section className="bg-navy-900 border-y border-navy-800" data-id="element-170">
      <div className="text-center mb-6 md:mb-16" data-id="element-171">
        <h2 className="text-xl md:text-4xl font-black text-white mb-2 md:mb-4" data-id="element-172">
          ¿QUÉ AGREGA EL PACK ÉLITE™?
        </h2>
        <p className="text-sm md:text-xl text-gold-400" data-id="element-173">
          El sistema para profesores que no solo quieren enseñar — quieren
          crecer
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-4 md:gap-12 max-w-6xl mx-auto" data-id="element-174">
        {/* Coreografias */}
        <div className="bg-navy-800/50 rounded-2xl md:rounded-3xl p-4 md:p-8 border border-navy-700" data-id="element-175">
          <div className="flex items-start space-x-3 md:space-x-4 mb-4 md:mb-6" data-id="element-176">
            <div className="w-9 h-9 md:w-12 md:h-12 bg-magenta-500/20 rounded-lg md:rounded-xl flex items-center justify-center text-lg md:text-2xl flex-shrink-0" data-id="element-177">
              💃
            </div>
            <div data-id="element-178">
              <h3 className="text-sm md:text-2xl font-bold text-white" data-id="element-179">
                COREOGRAFÍAS COMPLETAS DE SUELO RESUELTAS
              </h3>
              <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-180">
                "20 coreografías listas para exhibiciones y competencias"
              </p>
            </div>
          </div>

          <div className="space-y-2 md:space-y-4" data-id="element-181">
            {[{
            bad: 'No sabés cómo estructurar una coreografía de suelo',
            good: '8 coreografías completas nivel iniciación (6 a 8 años)'
          }, {
            bad: 'Tus exhibiciones siempre quedan improvisadas',
            good: '8 coreografías completas nivel intermedio (9 a 11 años)'
          }, {
            bad: 'No tenés material coreográfico para alumnas avanzadas',
            good: '4 coreografías nivel avanzado (12 años en adelante)'
          }, {
            bad: 'No sabés cómo dirigir el ensayo y la puesta en escena',
            good: 'Guía completa de montaje, ensayo y presentación final'
          }].map((item, i) => <div key={i} className="bg-navy-900 rounded-lg md:rounded-xl p-2.5 md:p-4 border border-navy-800" data-id="element-182">
                <div className="flex items-start space-x-2 mb-2 pb-2 border-b border-navy-800/50" data-id="element-183">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-184" />
                  <span className="text-gray-400 text-xs md:text-sm" data-id="element-185">
                    {item.bad}
                  </span>
                </div>
                <div className="flex items-start space-x-2" data-id="element-186">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-white font-medium text-xs md:text-base" data-id="element-188">
                    {item.good}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Academia */}
        <div className="bg-navy-800/50 rounded-2xl md:rounded-3xl p-4 md:p-8 border border-navy-700" data-id="element-189">
          <div className="flex items-start space-x-3 md:space-x-4 mb-4 md:mb-6" data-id="element-190">
            <div className="w-9 h-9 md:w-12 md:h-12 bg-gold-500/20 rounded-lg md:rounded-xl flex items-center justify-center text-lg md:text-2xl flex-shrink-0" data-id="element-191">
              🏫
            </div>
            <div data-id="element-192">
              <h3 className="text-sm md:text-2xl font-bold text-white" data-id="element-193">
                ACADEMIA DE ARTÍSTICA: CREÁ Y GESTIONÁ TU NEGOCIO
              </h3>
              <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-194">
                "Abrí, organizá y llenó tu academia de gimnasia artística"
              </p>
            </div>
          </div>

          <div className="space-y-2 md:space-y-4" data-id="element-195">
            {[{
            bad: 'No sabés cómo montar tu propia academia desde cero',
            good: 'Guía paso a paso para crear tu espacio propio'
          }, {
            bad: 'Cobrás lo mismo de siempre sin poder justificar una suba',
            good: 'Estructura de precios, tarifas y modalidades de cobro'
          }, {
            bad: 'No tenés presencia profesional en redes sociales',
            good: 'Marketing en Instagram y Facebook para academias de gimnasia artística'
          }, {
            bad: 'No contás con documentación profesional',
            good: 'Contratos, reglamentos y documentación lista para usar'
          }].map((item, i) => <div key={i} className="bg-navy-900 rounded-lg md:rounded-xl p-2.5 md:p-4 border border-navy-800" data-id="element-196">
                <div className="flex items-start space-x-2 mb-2 pb-2 border-b border-navy-800/50" data-id="element-197">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-198" />
                  <span className="text-gray-400 text-xs md:text-sm" data-id="element-199">
                    {item.bad}
                  </span>
                </div>
                <div className="flex items-start space-x-2" data-id="element-200">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-201" />
                  <span className="text-white font-medium text-xs md:text-base" data-id="element-202">
                    {item.good}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}